module.exports = __webpack_public_path__ + "img/amex-square.ddb8bf8b.svg";